// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-uQH","title":"styles_title__3UU9j"};